import { ChevronDown } from "lucide-react";

const faqs = [
    {
        q: "Wie lange dauert eine iPhone- oder Samsung-Reparatur?",
        a: "Die meisten Reparaturen – zum Beispiel Display tauschen oder Akku tauschen – dauern 60–120 Minuten. In der Zwischenzeit können Sie entspannt im DEZ einkaufen.",
    },
    {
        q: "Was kostet es, das Display oder den Akku zu tauschen?",
        a: "Der Preis hängt vom Modell ab. Vor jeder Reparatur nennen wir Ihnen einen Festpreis – direkt vor Ort oder per WhatsApp, wenn Sie uns ein Foto schicken.",
    },
    {
        q: "Welche Handys reparieren Sie in Regensburg?",
        a: "iPhone, Samsung Galaxy, Huawei, Xiaomi, Google Pixel, OnePlus, Oppo, Sony und viele weitere Modelle.",
    },
    {
        q: "Wo finde ich die Handyreparatur im DEZ?",
        a: "Im Donau-Einkaufszentrum Regensburg, Weichser Weg 5, 93059 Regensburg – Ebene 2. Geöffnet Montag bis Samstag von 10 bis 20 Uhr.",
    },
];

export const HandyFaq = () => (
    <section className="py-20 md:py-24 border-t border-line" data-testid="handy-faq">
        <div className="max-w-[1000px] mx-auto px-6 md:px-12">
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1] text-ink mb-10">
                Häufige Fragen zur <span className="italic text-brand">Handyreparatur</span> in Regensburg.
            </h2>
            <div className="divide-y divide-ink/10 border-y border-ink/10">
                {faqs.map((f, i) => (
                    <details key={f.q} className="group py-5" data-testid={`handy-faq-item-${i}`}>
                        <summary className="flex cursor-pointer list-none items-center justify-between gap-6 font-display text-lg md:text-xl text-ink">
                            {f.q}
                            <ChevronDown size={20} className="shrink-0 text-brand transition-transform duration-300 group-open:rotate-180" />
                        </summary>
                        <p className="mt-3 font-body text-sm md:text-base font-light text-inkSoft leading-relaxed">{f.a}</p>
                    </details>
                ))}
            </div>
        </div>
    </section>
);
